
import "././node_modules/bootstrap/dist/css/bootstrap.min.css"
import "././node_modules/bootstrap/dist/js/bootstrap.bundle"
// Style Sheets
import './src/styles/theme.scss';
import "././static/font/all.min.css";

import ReactDOM from "react-dom/client"

export const replaceHydrateFunction = () => {

    return (element, container) => {
        const root = ReactDOM.createRoot(container)
        root.render(element)
    }
}

